<div class="content-card mat-white-bg">

  <mat-table class="products-table"
    #table [dataSource]="users"
    matSort
    [@animateStagger]="{value:'50'}"
    fusePerfectScrollbar>


    <!-- Name Column -->
    <ng-container cdkColumnDef="eventTitle">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'event.title' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <p class="text-truncate">{{user.event.title}}</p>
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="color">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <div class="color" [style.borderTopColor]="user.event.eventType.color"></div>
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="eventType">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'event.eventType' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <div class="color" [style.borderTopColor]="user.event.eventType.color"></div>
        <p class="text-truncate">{{user.event.eventType.name}}</p>
      </mat-cell>
    </ng-container>


    <ng-container cdkColumnDef="credits">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'event.credits' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (user.event.credits && user.isOnEvent) {
          <p class="text-truncate possible-credit" >{{user.event.credits}}</p>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="type">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (!user.isOnEvent) {
          <p class="text-truncate " >Warteliste</p>
        }
        @if (user.isOnEvent) {
          <p class="text-truncate " >gebuchte</p>
        }
      </mat-cell>
    </ng-container>


    <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

    <mat-row *cdkRowDef="let user; columns: displayedColumns;"
      class="product"
      [ngClass]="{'isOnEvent': user.isOnEvent, 'noInEvent': !user.isOnEvent}"
      matRipple>
    </mat-row>

  </mat-table>

  <mat-paginator #paginator
    [length]="users.filteredData.length"
    [pageIndex]="0"
    [pageSize]="50"
    [pageSizeOptions]="[25, 50, 100]">
  </mat-paginator>

</div>
